
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import FAQ from "../Components/Faq/FAQ";
import AddFAQ from "../Components/Faq/AddFAQ";
import EditFAQ from "../Components/Faq/EditFAQ";
import ViewFAQ from "../Components/Faq/viewFAQ";

const FaqRoutes = () => {
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');
  return (
    <Routes>
      <Route path="/faq" element={<FAQ />}></Route>
      <Route path="/faq/addFQ" element={canAdd ? <AddFAQ /> : <Navigate to="/faq" replace />}></Route>
      <Route path="/faq/edit/:id" element={canEdit ? <EditFAQ /> : <Navigate to="/faq" replace />}></Route>
      <Route path="/faq/view/:id" element={canEdit ? <ViewFAQ /> : <Navigate to="/faq" replace />}></Route>
    </Routes>
  );
};
export default FaqRoutes;
